import { formatMinutesToParts } from '@components/_SiteWide/Form/HourMinuteInput'
import { OverrideActionCellRenderer } from '@components/DriverTracking/Dwell/components/OverrideActionCell'
import { TemporaryOverrideForm } from '@components/DriverTracking/Dwell/components/TemporaryOverrideForm'
import { Texto } from '@gravitate-js/excalibrr'
import { Form } from 'antd'
import moment from 'moment'
import React, { useState } from 'react'

function PopoverMetadata({ terminal }) {
  return (
    <>
      <Texto weight='bold'>Terminal</Texto>
      <Texto>{terminal}</Texto>
    </>
  )
}

function TerminalDwellOverrideForm({
  dwellOverride,
  terminal,
  handleOverride,
  handleDelete,
  form,
  closeForm,
  timezone,
}) {
  return (
    <TemporaryOverrideForm
      metadataComponent={<PopoverMetadata terminal={terminal} />}
      dwellOverride={dwellOverride}
      form={form}
      handleOverride={handleOverride}
      handleDelete={handleDelete}
      closeForm={closeForm}
      timezone={timezone}
    />
  )
}

export function DwellOverrideCell({ params, createHandleOverride, createHandleDeleteOverride, hasEdits, timezone }) {
  if (params.node.group) return null
  const [form] = Form.useForm()
  const [popoverOpen, setPopoverOpen] = useState(false)

  const hidePopover = () => {
    setPopoverOpen(false)
  }

  const handleOpenPopoverChange = (newOpen: boolean) => {
    setPopoverOpen(newOpen)
  }

  const handleOverride = createHandleOverride(params)
  const handleDelete = createHandleDeleteOverride(params)

  const terminal = params.data?.terminal_name

  const dwellOverride = params.data?.override_expiry

  return (
    <OverrideActionCellRenderer
      overrideForm={
        <TerminalDwellOverrideForm
          form={form}
          handleOverride={handleOverride}
          handleDelete={handleDelete}
          terminal={terminal}
          dwellOverride={dwellOverride}
          closeForm={hidePopover}
          timezone={params.data?.override_expiry_local}
        />
      }
      hadEdits={hasEdits}
      overrideDwell={params.data?.override_dwell}
      open={popoverOpen}
      handleOpenChange={handleOpenPopoverChange}
    />
  )
}
